import { useHistoryTabEvents } from "../../hooks/use_history_tab_events";
import { HistoryEntry } from "../history_entry";
import css from "./history_entries_list.module.scss";

export const HistoryEntriesList = () => {
  const { data } = useHistoryTabEvents();

  const historyEntries = data?.entries || [];

  return (
    <div className={css.entriesList}>
      {historyEntries.map((entry) => (
        <HistoryEntry key={`${entry.id}-${entry.event}-${entry.createdAt}`} entry={entry} />
      ))}
    </div>
  );
};
